var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.listClassName},_vm._l((_vm.routes),function(route){return (route.authRequired == false || route.authRequired == _vm.userAuthStatus)?_c('li',{key:route.id,class:_vm.listItemClassName},[_c('router-link',{staticStyle:{"color":"#fff"},attrs:{"to":route.path}},[_vm._v(" "+_vm._s(route.name)+" ")])],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }